// Property mappings for different tools/views
export const propertyMappings = {
  car_stock_search: {
    id: 'vehicleid',
    title: 'title',
    description: 'description',
    price: 'saleprice',
    retailPrice: 'retailprice',
    mileage: 'km',
    image: 'urlmainimage',
    colour: 'colour',
    colourBase: 'colourbase',
    url: 'url',
    available: 'available',
    usageType: 'usagetype',
    brand: 'brand',
    registrationYear: 'registrationyear',
  },
};

export async function urlBase64ToUint8Array(base64String) {
  const padding = '='.repeat((4 - (base64String.length % 4)) % 4);
  const base64 = (base64String + padding).replace(/\-/g, '+').replace(/_/g, '/');

  const rawData = window.atob(base64);
  const outputArray = new Uint8Array(rawData.length);

  for (let i = 0; i < rawData.length; ++i) {
    outputArray[i] = rawData.charCodeAt(i);
  }
  return outputArray;
}

export const mapItems = (items, mappings) => {
  if (!Array.isArray(items) || !mappings) {
    return [];
  }

  return items.map(item => {
    const mappedItem = {};
    Object.entries(mappings).forEach(([key, value]) => {
      // Handle nested properties if needed
      if (value.includes('.')) {
        const props = value.split('.');
        let propValue = item;
        for (const prop of props) {
          propValue = propValue?.[prop];
        }
        mappedItem[key] = propValue;
      } else {
        mappedItem[key] = item[value];
      }
    });
    return mappedItem;
  });
};

export const formatDate = (date) => {
  if (!date) return '';
  return new Date(date).toLocaleDateString();
};

export const formatPrice = (price) => {
  if (!price) return '';
  return new Intl.NumberFormat('it-IT', {
    style: 'currency',
    currency: 'EUR',
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  }).format(price);
};

export const truncateText = (text, maxLength) => {
  if (!text || text.length <= maxLength) return text;
  return `${text.substring(0, maxLength)}...`;
}; 